import React, {ReactElement, useContext, useEffect, useRef} from "react";
import './Button.less';

import {LOADING, PLAY, PlayerContext, PlayerContextDispatch, STATUS_ACTION, StatusAction, STOP} from "../PlayerReducer";


export const Button = (): ReactElement => {

    const { status, station } = useContext(PlayerContext)

    const dispatch = useContext(PlayerContextDispatch);

    const firstLoad = useRef(false);
    let currentState = 'state-stop';


    switch (status) {
        case LOADING:
            currentState = 'state-loading';
            break;
        case PLAY:
            currentState = 'state-play';
            break;
    }

    let disabledPlay = '';
    if (!station) {
        disabledPlay = 'play-disabled';
    }


    useEffect(()=>{
        if (firstLoad.current)
            window.parent.postMessage('radiaczplayerstatus-' + status, "*")
        else
            firstLoad.current = true;
    }, [status])

    return <a href="#" role="button" className={`play ${currentState} ${disabledPlay}`} onClick={(ev)=>{
        ev.preventDefault();
        if (disabledPlay)
            return;

        if (status === STOP)
        {
            dispatch({
                type: STATUS_ACTION,
                payload: LOADING
            } as StatusAction)
        }
        else
        {
            dispatch({
                type: STATUS_ACTION,
                payload: STOP
            } as StatusAction)
        }
    }}>
        {/*<div className="button-background"/> */}
        <div className="button-play">
            <div className="button-play-background-1"/>
            <div className="button-load-icon"/>
        </div>
        <div className={'button-icon'}/>
        <div className="dots">
            <div className="loading loading-0"/>
            <div className="loading loading-1"/>
            <div className="loading loading-2"/>
        </div>
    </a>

}
